import React, { useEffect } from "react"; //, { useEffect }

import { languageOptions } from "./../../Languages";
import {
  useLanguageContext,
  useLanguageActionContext,
} from "../../Context/LanguageContext";
import access_ControlStore from "../../Stores/Access_ControlStores";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";

export default function LanguageSelector() {
  const { language } = useLanguageContext();
  const UpdateLanguage = useLanguageActionContext();
  //const { language, changeLanguage } = useContext(GlobalContext);

  // set selected language by calling context method
  const handleChangeLanguage = (e) => UpdateLanguage(e.target.value);

  return (
    <div id="languageselector" className="btn-group">
      <select
        className="btn btn-info btn-sm dropdown-toggle dropdown-toggle-split btn-responsive"
        style={{ width: "45px" }}
        value={language}
        onChange={handleChangeLanguage}
      >
        {Object.entries(languageOptions).map(([id, lang]) => (
          <option
            key={"lang-" + id}
            value={id}
            className={"dropdown-item lang-" + lang}
          >
            {lang.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}
